import { Directive, Input, OnInit, ViewChild } from '@angular/core'
import { UntypedFormControl, Validators } from '@angular/forms'
import { ImageCache, IntakeService } from '@mmx/shared'

import { AppLoaderService } from '../../../app-loader'

@Directive({
  standalone: false,
})
export class IntakeFileUploadBaseDirective implements OnInit {
  @Input() id: any
  @Input() label: any
  @Input() required = false
  @Input() control: UntypedFormControl
  @Input() previewImageUrl: string

  @ViewChild('file', { static: false }) fileInput: any

  isLoading: boolean
  error: string
  hint: string
  file: File
  // previewImageUrl: string

  constructor(
    public loaderService: AppLoaderService,
    protected intakeService: IntakeService,
  ) {}

  ngOnInit() {
    this.tryInitPreviewFromImageCache()
  }

  addFiles() {
    this.fileInput.nativeElement.click()
  }

  saveImageDataToIntake(file: File) {
    const reader = new FileReader()
    reader.onload = async () => {
      try {
        this.isLoading = true
        this.intakeService.saveToImageCache(this.id, reader.result as string)

        const urls = await this.intakeService.saveFiles()
        const url = urls && urls[0]

        // Add value to form control
        this.control.setValue(url)

        this.previewImageUrl = url

        if (this.required) {
          this.control.clearValidators()
          this.control.updateValueAndValidity()
        }
        this.isLoading = false
      } catch (err) {
        this.error = err
      }
    }
    reader.readAsDataURL(file)
  }

  deleteImage() {
    this.error = ''
    this.previewImageUrl = null
    if (this.required) {
      this.control.setValidators(Validators.required)
      this.control.updateValueAndValidity()
    }
    if (this.fileInput) {
      this.fileInput.nativeElement.value = ''
    }

    this.intakeService.imageCache.delete(this.id)
  }

  private tryInitPreviewFromImageCache() {
    this.isLoading = true
    this.intakeService.imageCacheInitializationPromise.then(
      (imageCache: ImageCache) => {
        const imageCacheItem = imageCache.get(this.id)
        if (imageCacheItem) {
          this.previewImageUrl = imageCacheItem.url
          if (this.required) {
            this.control.clearValidators()
            this.control.updateValueAndValidity()
          }
        }
        this.isLoading = false
      },
    )
  }
}
